import $ from 'jquery';
import 'owl.carousel/src/js/owl.carousel';
import 'owl.carousel/src/js/owl.autoplay';
import 'owl.carousel/src/js/owl.navigation';
import 'owl.carousel/src/js/owl.support';
import analytics from '../../analytics';

const defaults = {
    margin: 20,
    autoWidth: true,
    loop: document.documentElement.clientWidth < 1024 ? false : true, // Enable looping only for desktop
    dots: true, // Needed to show page no.
    video: true,
    refreshClass: 'carousel-refresh',
    loadedClass: 'carousel-loaded',
    loadingClass: 'carousel-loading',
    rtlClass: 'carousel-rtl',
    responsiveClass: 'carousel-responsive',
    dragClass: 'carousel-drag',
    itemClass: 'carousel-item',
    stageClass: 'carousel-stage',
    stageOuterClass: 'carousel-stage-outer',
    grabClass: 'carousel-grab',
    carouselEventClass: '.js-carousel-items',
    carouselNavigationClass: '.js-carousel-nav',
    prevEventClass: null,
    nextEventClass: null,
    indicatorEventClass: null
};

class Carousel {
    constructor(carousel, option) {
        this.opts = Object.assign({}, defaults, option);
        this.carousel = $(carousel);
        this.carouselItems = this.carousel.find(this.opts.carouselEventClass);

        // Extend from data attributes
        this.opts = Object.assign({}, this.opts, this.carousel.data('carousel'));

        // Don't initialize if option is set
        if (this.carouselItems[0].children.length <= 1 || this.opts.init === false) {
            this.carouselItems.addClass(this.opts.loadedClass);
            this.carousel.find(this.opts.carouselNavigationClass).hide();
            return;
        }

        this.eventProxy();

        this.carouselItems.owlCarousel(this.opts);
    }

    eventProxy() {
        this.carouselItems.on('initialized.owl.carousel', () => {
            this.carousel.addClass(this.opts.loadedClass);

            setTimeout(() => {
                this.carouselItems.trigger('refresh.owl.carousel'); // items aligning bug fix
            }, 100);
        });

        if (this.opts.prevEventClass) {
            this.carousel.find(this.opts.prevEventClass).on('click', () => this.previous());
        }

        if (this.opts.nextEventClass) {
            this.carousel.find(this.opts.nextEventClass).on('click', () => this.next());
        }

        if (this.opts.indicatorEventClass) {
            const indicator = this.carousel.find(this.opts.indicatorEventClass);
            const indicatorText = indicator.text();

            this.carouselItems.on('changed.owl.carousel', (e) => this.indicator(e, indicator, indicatorText));
        }
    }

    previous() {
        this.carouselItems.trigger('prev.owl.carousel');
    }

    next() {
        this.carouselItems.trigger('next.owl.carousel');
    }

    indicator(e, indicator, text) {
        let textUpdated = text;
        textUpdated = textUpdated.replace('{{carouselCurrent}}', e.page.index + 1);
        textUpdated = textUpdated.replace('{{carouselTotal}}', e.item.count);

        indicator.text(textUpdated);
    }
}

const init = (elms, option) => {
    elms.forEach((carousel) => {
        carousel.carousel = new Carousel(carousel, option);
    });

    analytics.broadcast('carousel.init', { message: 'carousel initialized' });
};

export default { init };
